export default "__VITE_ASSET__48391b77__"